import { render, staticRenderFns } from "./SearchOfDoctor.vue?vue&type=template&id=5ea59d2a&scoped=true&"
import script from "./SearchOfDoctor.vue?vue&type=script&lang=js&"
export * from "./SearchOfDoctor.vue?vue&type=script&lang=js&"
import style0 from "./SearchOfDoctor.vue?vue&type=style&index=0&id=5ea59d2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea59d2a",
  null
  
)

export default component.exports